export default __webpack_public_path__ + "static/media/19.952fddc6.png";